<template>
  <div>
    <v-navigation-drawer app class="dont-print-header" v-model="drawer">
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar height="90%" width="90%">
            <v-img
              alt="Vuetify Name"
              class="mt-1"
              contain
              :src="
                company.logo_path
                  ? `${mediaUrl + company.logo_path}`
                  : require('../../assets/vastrosa-logo.png')
              "
              width="150"
              height="150"
            />
          </v-list-item-avatar>
        </v-list-item>
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{
                  user.first_name != null
                    ? user.first_name + " " + user.last_name
                    : user.email
                }}
              </v-list-item-title>
              <v-list-item-subtitle>{{
                roleName == "SUPER ADMIN" && company.id != null
                  ? "ADMIN"
                  : roleName
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="
              roleName == 'ADMIN' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
            :to="`/companies/${encryptIt(this.company.id)}`"
          >
            <v-list-item-title>Company</v-list-item-title>
          </v-list-item>
          <v-list-item to="/notifications" @click="hide_bell = true">
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item
          :to="`/companies`"
          v-if="roleName == 'SUPER ADMIN' && company.id == null"
        >
          <v-list-item-icon>
            <v-icon>mdi-office-building-marker-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Companies</v-list-item-title>
        </v-list-item>
        <!-- Home has a single tab, so show it as a direct link instead of a collapsible -->
        <v-list-item :to="`/home`" v-if="can('HOME.VIEW')">
          <v-list-item-icon>
            <v-icon size="25">mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <!-- Users has a single tab, so show it as a direct link instead of a collapsible -->
        <v-list-item :to="`/users`" v-if="can('USERS.VIEW')">
          <v-list-item-icon>
            <v-icon size="25">mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Users</v-list-item-title>
        </v-list-item>
        <!--<v-list-item :to="`/device-reset-requests`">
          <v-list-item-icon>
            <v-icon>mdi-cellphone-remove</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Device Reset</v-list-item-title>
        </v-list-item>
        <v-list-item :to="`/location-reset-requests`">
          <v-list-item-icon>
            <v-icon>mdi-map-marker-remove-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Location Reset</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-group
          no-action
          :value="false"
          v-if="
            roleName == 'ADMIN' ||
            (roleName == 'SUPER ADMIN' && company.id != null)
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-store</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Outlets</v-list-item-title
            >
          </template>
          <v-list-item :to="`/outlets`">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          no-action
          :value="false"
          v-if="
            roleName == 'ADMIN' ||
            (roleName == 'SUPER ADMIN' && company.id != null)
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-map-marker-path </v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1">Pjps</v-list-item-title>
          </template>
          <v-list-item :to="`/pjps`">
            <v-list-item-icon>
              <v-icon>mdi-table-of-contents </v-icon>
            </v-list-item-icon>
            <v-list-item-title>List</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/pjp-references`">
            <v-list-item-icon>
              <v-icon>mdi-content-duplicate </v-icon>
            </v-list-item-icon>
            <v-list-item-title>References</v-list-item-title>
          </v-list-item>
        </v-list-group> -->
        <!-- Catalog: what the company sells -->
        <v-list-group
          no-action
          :value="false"
          v-if="canAny(['CATEGORIES.VIEW', 'PRODUCTS.VIEW'])"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-tag-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Catalog</v-list-item-title
            >
          </template>
          <v-list-item :to="`/categories`" v-if="can('CATEGORIES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-folder-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Categories</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/sub-categories`" v-if="can('CATEGORIES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-file-tree-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sub-Category</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/products`" v-if="can('PRODUCTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Products</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Catalog -->

        <!-- Inventory: physical stock + the delivery addresses stock moves to -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            canAny([
              'COMPANY_STOCKS.VIEW',
              'RETURN_STOCKS.VIEW',
              'STOCK_LOGS.VIEW',
              'ASSIGNED_STOCKS.VIEW',
              'ADMIN_STOCK_TRACKING.VIEW',
            ])
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-archive-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Inventory</v-list-item-title
            >
          </template>
          <v-list-item
            :to="`/company-stocks`"
            v-if="can('COMPANY_STOCKS.VIEW')"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-warehouse</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Company Stocks</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/return-stocks`" v-if="can('RETURN_STOCKS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-backup-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Return Stock</v-list-item-title>
          </v-list-item>

          <v-list-item :to="`/stock_logs`" v-if="can('STOCK_LOGS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-clipboard-text-clock</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Stock Logs</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/assigned_stocks`"
            v-if="can('ASSIGNED_STOCKS.VIEW')"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-package-variant-closed</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Assigned Stocks</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="`/stock-assignments`"
            v-if="can('STOCK_ASSIGNMENTS.VIEW')"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-handshake-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Stock Payments</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item :to="`/admin/stock-tracking`" v-if="can('ADMIN_STOCK_TRACKING.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Stock Tracking Dashboard</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
        <!-- /Inventory -->

        <!-- Purchasing: vendors and the buying flow with them -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            canAny([
              'PURCHASE_ORDERS.VIEW',
              'PURCHASE_BILLS.VIEW',
              'VENDOR_PAYMENTS.VIEW',
              'PURCHASE_RETURNS.VIEW',
            ])
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-truck-delivery-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Purchasing</v-list-item-title
            >
          </template>
          <v-list-item :to="`/purchase-orders`" v-if="can('PURCHASE_ORDERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-cart-arrow-down</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Purchase Orders</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/purchase-bills`" v-if="can('PURCHASE_BILLS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-receipt-text-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Purchase Bills</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/vendor-payments`" v-if="can('VENDOR_PAYMENTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-cash-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vendor Payments</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/purchase-returns`" v-if="can('PURCHASE_RETURNS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-truck-fast-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Purchase Returns</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Purchasing -->

        <!-- Sales: orders coming in, the outlets they come through, and the sales/stock dashboard -->
        <v-list-group
          no-action
          :value="false"
          v-if="can('ORDERS.VIEW')"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-point-of-sale</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Sales</v-list-item-title
            >
          </template>
          <v-list-item :to="`/orders`" v-if="can('ORDERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Orders</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/replacements`" v-if="can('REPLACEMENTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-swap-horizontal</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Replacements</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/sale-linkage`" v-if="can('SALE_LINKAGE.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-source-branch</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sale Linkage</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/sale-returns`" v-if="can('SALE_RETURNS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-keyboard-return</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sale Returns</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/wishlists`" v-if="can('WISHLISTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>WishLists</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item :to="`/carts`">
            <v-list-item-icon>
              <v-icon size="25">mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Carts</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/sales-stock-management`" v-if="can('ORDERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-store-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sales & Stock Management</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Sales -->

        <!-- Accounting: money leaving the business -->
        <v-list-group
          no-action
          :value="false"
          v-if="canAny(['ORDERS.VIEW', 'EXPENSES.VIEW', 'EXPENSE_CATEGORIES.VIEW'])"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-finance</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Accounting</v-list-item-title
            >
          </template>
          <v-list-item :to="`/accounting`" v-if="can('ORDERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-calculator</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Accounting Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/expenses`" v-if="can('EXPENSES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-cash-minus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Expenses</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/expense-categories`" v-if="can('EXPENSE_CATEGORIES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Expense Categories</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Accounting -->

        <!-- Reporting has a single tab, so show it as a direct link instead of a collapsible -->
        <v-list-item :to="`/reporting`" v-if="can('ORDERS.VIEW')">
          <v-list-item-icon>
            <v-icon size="25">mdi-chart-bar</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Reporting Dashboard</v-list-item-title>
        </v-list-item>
        <!-- /Reporting -->

        <!-- Marketing: storefront-facing content -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            canAny(['BANNERS.VIEW', 'MARKETING_CAMPAIGNS.VIEW']) ||
            roleName == 'ADMIN' ||
            roleName == 'SUPER ADMIN'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-bullhorn-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Marketing</v-list-item-title
            >
          </template>
          <v-list-item :to="`/feedback-questions`" v-if="can('BANNERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-comment-question-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Feedback Questions</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/marketing-campaigns`" v-if="can('MARKETING_CAMPAIGNS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-bullhorn</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Marketing Campaigns</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/payment-qr`"
            v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN'"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-qrcode</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Payment QR</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Marketing -->

        <!-- Master: alphabetical -->
        <v-list-group
          no-action
          :value="false"
          v-if="
            canAny([
              'BANNERS.VIEW',
              'VALUE_LISTS.VIEW',
              'LOCATIONS.VIEW',
              'STORES.VIEW',
              'VENDORS.VIEW',
            ])
          "
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-database-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Master</v-list-item-title
            >
          </template>
          <v-list-item :to="`/banners`" v-if="can('BANNERS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-view-carousel</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Banners</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/colors`" v-if="can('VALUE_LISTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-palette</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Colors</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/locations`" v-if="can('LOCATIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Locations</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/stores`" v-if="can('STORES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-store-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Stores</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/vendors`" v-if="can('VENDORS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Vendors</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Master -->

        <!-- Settings: system/RBAC configuration + the logged-in user's own
             Profile, which must stay reachable regardless of permissions -->
        <v-list-group no-action :value="false">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Settings</v-list-item-title
            >
          </template>

          <v-list-item
            :to="`/profile/${encryptIt(user.id)}`"
            @click="hide_bell = true"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-account-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/modules`" v-if="can('MODULES.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-view-module</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Modules</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/permissions`" v-if="can('PERMISSIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-key-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Permissions</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/values`">
            <v-list-item-icon>
              <v-icon size="25">mdi-arrow-expand-all</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Value</v-list-item-title>
          </v-list-item> -->
          <v-list-item :to="`/value-lists`" v-if="can('VALUE_LISTS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-format-list-text</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ValueList</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/positions`" v-if="can('POSITIONS.VIEW')">
            <v-list-item-icon>
              <v-icon size="25">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Position</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Settings -->

        <!-- Ticket has a single tab, so show it as a direct link instead of a collapsible -->
        <v-list-item :to="`/tickets`" v-if="can('TICKETS.VIEW')">
          <v-list-item-icon>
            <v-icon size="25">mdi-ticket-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Tickets</v-list-item-title>
        </v-list-item>
        <!-- /Ticket -->

        <!-- Admin & Audit: trash, change history, account-deletion moderation.
             Deleted Users and User Timestamps were always unconditionally
             visible before this group existed, so this group itself carries
             no v-if - only Delete Requests keeps its own role check, exactly
             as before, just relocated here. -->
        <v-list-group no-action :value="false">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon size="25">mdi-shield-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-subtitle-1"
              >Admin & Audit</v-list-item-title
            >
          </template>
          <v-list-item :to="`/users?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-trash-can-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Deleted Users</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item :to="`/outlets?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-store</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Outlets</v-list-item-title>
          </v-list-item>
          <v-list-item :to="`/pjps?open_trash=true`">
            <v-list-item-icon>
              <v-icon size="25">mdi-map-marker-path</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Pjps</v-list-item-title>
          </v-list-item> -->
          <!-- <v-list-group
            no-action
            sub-group
            :value="false"
            v-if="
              roleName == 'ADMIN' ||
              user.position.name == 'INTERNAL TEAM' ||
              (roleName == 'SUPER ADMIN' && company.id != null)
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item :to="`/modules?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Modules</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/permissions?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Permissions</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/positions?open_trash=true`" link>
              <v-list-item-icon>
                <v-icon size="25">mdi-arrow-expand-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Position</v-list-item-title>
            </v-list-item>
          </v-list-group> -->
          <v-list-item :to="`/user-timestamps`">
            <v-list-item-icon>
              <v-icon size="25">mdi-monitor-eye</v-icon>
            </v-list-item-icon>
            <v-list-item-title>User Timestamps</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="`/account-delete-requests`"
            v-if="roleName == 'ADMIN' || roleName == 'SUPER ADMIN'"
          >
            <v-list-item-icon>
              <v-icon size="25">mdi-account-remove</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Delete Requests</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- /Admin & Audit -->
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="white"
      class="dont-print-header"
      style="overflow-x: auto; overflow-y: hidden"
    >
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="drawer = !drawer"
        color=""
      ></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <router-link to="/">
          <v-img
            alt="Vuetify Name"
            class="mt-1"
            contain
            min-width="50"
            :src="
              company.logo_path
                ? `${mediaUrl + company.logo_path}`
                : require('../../assets/vastrosa-logo.png')
            "
            width="150"
            height="50"
        /></router-link>
      </div>
      &nbsp;
      <span class="my-auto" style="font-size: 25px; min-width: max-content">
        Hey,
        {{ user.user_name != null ? user.user_name : user.email }}
        {{ company.name ? "[ " + company.name + " ]" : "" }}
      </span>
      <v-container class="mt-5 ml-15" fluid v-if="roleName == 'SUPER ADMIN'">
        <v-switch
          inset
          @change="switch_to(company.id)"
          :loading="isSwitching"
          v-model="is_acting_admin"
          :label="`${is_acting_admin ? 'ADMIN' : 'SUPERADMIN'}`"
        ></v-switch>
      </v-container>
      <v-spacer></v-spacer>

      <!-- Notification Bell Icon (Admin Only) -->
      <div v-if="isAdmin">
        <v-badge
          :content="unreadCount"
          :value="unreadCount > 0"
          color="red"
          overlap
          offset-x="20"
          offset-y="20"
        >
          <v-btn icon @click="openNotifications">
            <v-icon color="grey darken-2">mdi-bell</v-icon>
          </v-btn>
        </v-badge>

        <!-- Notification Dialog (Centered) -->
        <v-dialog v-model="showNotifications" max-width="800" scrollable>
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-bell</v-icon>
              <span>Notifications</span>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                color="white"
                @click="markAllAsRead"
                v-if="unreadCount > 0"
                title="Mark all as read"
              >
                <v-icon small>mdi-check-all</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                color="white"
                @click="showNotifications = false"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-0" style="max-height: 600px">
              <v-list v-if="notifications.length > 0">
                <v-list-item
                  v-for="notification in notifications"
                  :key="notification.id"
                  :class="{ 'blue-grey lighten-5': !notification.is_read }"
                  class="py-3"
                >
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ notification.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ notification.message }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="caption mt-1">
                      {{ notification.time_ago }}
                    </v-list-item-subtitle>

                    <!-- Low Stock Data Table -->
                    <div
                      v-if="
                        notification.type === 'low_stock' &&
                        notification.data &&
                        notification.data.length > 0
                      "
                      class="mt-3"
                    >
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">User</th>
                              <th class="text-left">Contact</th>
                              <th class="text-left">Product</th>
                              <th class="text-right">Available</th>
                              <th class="text-right">Stock %</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(alert, index) in notification.data.slice(
                                0,
                                5,
                              )"
                              :key="index"
                            >
                              <td>
                                <div class="text-caption">
                                  {{ alert.user_name }}
                                </div>
                                <v-chip
                                  x-small
                                  :color="getPositionColor(alert.position)"
                                >
                                  {{ getPositionAbbr(alert.position) }}
                                </v-chip>
                              </td>
                              <td class="text-caption">
                                <div>📞 {{ alert.user_phone }}</div>
                                <div>✉️ {{ alert.user_email }}</div>
                              </td>
                              <td class="text-caption">
                                <div class="font-weight-bold">
                                  {{ alert.product_name }}
                                </div>
                                <div>{{ alert.variant_info }}</div>
                              </td>
                              <td class="text-right">
                                <span
                                  :class="
                                    alert.percentage < 1
                                      ? 'error--text font-weight-bold'
                                      : 'warning--text'
                                  "
                                >
                                  {{ alert.available_quantity }}
                                </span>
                              </td>
                              <td class="text-right">
                                <span
                                  :class="
                                    alert.percentage < 1
                                      ? 'error--text font-weight-bold'
                                      : 'warning--text'
                                  "
                                >
                                  {{ alert.percentage }}%
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div
                        v-if="notification.data.length > 5"
                        class="text-caption text-center mt-2 grey--text"
                      >
                        + {{ notification.data.length - 5 }} more items
                      </div>
                    </div>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      @click="markAsRead(notification.id)"
                      v-if="!notification.is_read"
                      title="Mark as read"
                    >
                      <v-icon small color="primary">mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div v-else class="pa-10 text-center grey--text">
                <v-icon size="64" color="grey lighten-1">mdi-bell-off</v-icon>
                <div class="mt-3 text-h6">No notifications</div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <!-- Account Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-avatar color="primary" v-bind="attrs" v-on="on" class="ml-2">
            <v-icon dark> mdi-account-circle </v-icon>
          </v-avatar>
        </template>
        <v-list dense>
          <v-list-item
            :to="`/profile/${encryptIt(user.id)}`"
            @click="hide_bell = true"
          >
            <v-list-item-title>My Profile</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <router-view />
    <!-- Clear Success Dialog Box -->
    <v-dialog v-model="show_company_dialog" width="850">
      <v-card rounded="xxl">
        <v-card-title> <h1>Switch to Admin</h1> </v-card-title>
        <v-card-subtitle class="my-1">
          Please select the company whose admin portal you'd like to switch to.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col md="6">
              <v-text-field
                solo
                rounded
                v-model="form.search_keyword"
                label="Search ... "
                clearable
                color="#e60040"
                @click:clear="(form.search_keyword = null), getCompanies()"
                prepend-inner-icon="mdi-magnify"
                @keydown.enter="getCompanies"
                @change="page = 1"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <v-row v-else>
            <v-col md="12">
              <v-simple-table fixed-header height="285" class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Admin Name</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="companies.length != 0">
                    <tr
                      v-for="(company, i) in companies"
                      :key="`company_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': companies.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="company.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Company is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="company.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-cross-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Company is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar rounded>
                          <v-img
                            alt="Vuetify Name"
                            class="mt-1"
                            contain
                            min-width="35"
                            :src="
                              company.logo_path
                                ? `${mediaUrl + company.logo_path}`
                                : require('../../assets/vastrosa-logo.png')
                            "
                            width="35"
                            height="35"
                          />
                        </v-avatar>
                        &nbsp;
                        {{ company.name || "" }}
                      </td>
                      <td>{{ company.email || "" }}</td>
                      <td>{{ company.admin_name || "" }}</td>
                      <td class="text-right">
                        <v-btn
                          class="ml-2"
                          fab
                          x-small
                          color="primary"
                          @click="changeCompany(company.id)"
                        >
                          <v-icon dark> mdi-account-switch-outline </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";
import axios from "axios";
import store from "@/store";

export default {
  data() {
    return {
      form: {
        search_keyword: "",
      },
      hide_bell: false,
      drawer: true,
      is_acting_admin: false,
      companyName: "",
      selectedCompanyId: "",
      company_data: {},
      companies: [],
      is_company_user: false,
      isLoading: false,
      isSwitching: false,
      show_company_dialog: false,
      // Notification data
      notifications: [],
      unreadCount: 0,
      notificationInterval: null,
      showNotifications: false,
    };
  },
  computed: {
    isAdmin() {
      // Check if user is admin
      return this.roleName === "ADMIN" || this.roleName === "SUPER ADMIN";
    },
  },
  mounted() {
    let company = store.getters["auth/company"];
    if (Object.keys(company).length > 0) {
      this.selectedCompanyId = company.id;
      if (this.roleName == "SUPER ADMIN") {
        this.is_acting_admin = true;
        console.log(this.is_acting_admin);
      }
      this.is_company_user = company ? true : false;
    }

    // Fetch notification count if admin
    if (this.isAdmin) {
      this.fetchUnreadCount();

      // Subscribe to real-time notifications
      this.subscribeToNotifications();

      // Fallback polling every 60 seconds (in case WebSocket fails)
      this.notificationInterval = setInterval(() => {
        this.fetchUnreadCount();
      }, 60000);
    }
  },
  beforeDestroy() {
    // Clear interval when component is destroyed
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }

    // Leave notification channel
    if (this.isAdmin && this.$echo) {
      this.$echo.leave(`notifications.${this.user.id}`);
    }
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
    isActingAdmin() {
      let response = false;
      if (this.roleName == "SUPER ADMIN" && this.company.id != null) {
        response = true;
      }
      return response;
    },
    // Scroll back to the 1st validation error Message
    scrollToSection(selector) {
      // Example: smooth scroll to the specific section
      const element = document.querySelector(selector);
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - window.innerHeight / 2;
      window.scrollTo({
        top: middle,
        behavior: "smooth",
      });
      console.log(selector);
    },
    async getCompanies() {
      this.isLoading = true;
      this.form.search_keyword = this.form.search_keyword
        ? this.form.search_keyword
        : "";
      this.form.is_active = this.form.is_active ? this.form.is_active : "";
      let companies = [];
      let query =
        "search_keyword=" +
        this.form.search_keyword +
        "&is_active=" +
        this.form.is_active;
      companies = await axios.get(`companies?${query}`);
      this.companies = companies.data.data;
      this.count = companies.data.count;
      this.isLoading = false;
    },
    changeCompany(companyId) {
      this.selectedCompanyId = companyId;
      let company = this.companies.find((s) => s.id == this.selectedCompanyId);
      if (company) {
        console.log(company);
        store.dispatch("auth/setCompany", company);
        this.is_company_user = true;
      } else {
        store.dispatch("auth/setCompany", "");
        this.is_company_user = false;
      }
      // // window.location.href = "/auth/login";
      this.isSwitching = false;
      this.show_company_dialog = false;
      // this.$router.push("/auth/login");
    },
    switch_to(companyId = "") {
      this.isSwitching = true;
      console.log(this.is_acting_admin);
      if (this.is_acting_admin == true) {
        console.log("CompanyID " + companyId);
        console.log("Already SuperAdmin Switching to Admin");
        this.show_company_dialog = true;
      } else {
        console.log("Already Acting Admin Switching to SuperAdmin");
        this.selectedCompanyId = null;
        this.changeCompany();
      }
    },
    // Notification Methods
    async fetchUnreadCount() {
      try {
        const response = await axios.get("notifications/unread-count");
        if (response.data.success) {
          this.unreadCount = response.data.count;
        }
      } catch (error) {
        console.error("Failed to fetch unread count:", error);
      }
    },
    async openNotifications() {
      this.showNotifications = true;
      try {
        const response = await axios.get(
          "notifications?per_page=20&user_id=" + this.user.id,
        );
        if (response.data.success) {
          this.notifications = response.data.data;
        }
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    },
    async markAsRead(notificationId) {
      try {
        const response = await axios.post(
          `notifications/${notificationId}/mark-as-read`,
        );
        if (response.data.success) {
          // Update local notification
          const notification = this.notifications.find(
            (n) => n.id === notificationId,
          );
          if (notification) {
            notification.is_read = true;
          }
          // Refresh unread count
          this.fetchUnreadCount();
        }
      } catch (error) {
        console.error("Failed to mark notification as read:", error);
      }
    },
    async markAllAsRead() {
      try {
        const response = await axios.post("notifications/mark-all-as-read");
        if (response.data.success) {
          // Update all local notifications
          this.notifications.forEach((n) => {
            n.is_read = true;
          });
          // Reset unread count
          this.unreadCount = 0;
        }
      } catch (error) {
        console.error("Failed to mark all notifications as read:", error);
      }
    },
    subscribeToNotifications() {
      if (!this.$echo || !this.user || !this.user.id) {
        console.warn(
          "Echo or user not available for notification subscription",
        );
        return;
      }

      const channelName = `notifications.${this.user.id}`;
      console.log(`📡 Subscribing to private channel: ${channelName}`);

      this.$echo
        .private(channelName)
        .listen(".notification.created", (data) => {
          console.log("🔔 New notification received:", data);

          // Update unread count immediately
          this.unreadCount = data.unread_count;

          // Optionally show browser notification
          if (Notification.permission === "granted") {
            new Notification(data.notification.title, {
              body: data.notification.message,
              icon: "/favicon.ico",
            });
          }

          // If notification dialog is open, refresh the list
          if (this.showNotifications) {
            this.openNotifications();
          }
        })
        .error((error) => {
          console.error(
            "❌ Error subscribing to notifications channel:",
            error,
          );
        });

      console.log("✅ Subscribed to notification channel");
    },
    getPositionAbbr(positionName) {
      const abbreviations = {
        "DISTRIBUTOR/DEALER": "Dis",
        "FRANCHISE/OUTLET PARTNER": "Fra",
        "SALE EXECUTIVE": "SE",
      };
      return (
        abbreviations[positionName.toUpperCase()] ||
        positionName.substring(0, 3)
      );
    },
    getPositionColor(positionName) {
      const colors = {
        "DISTRIBUTOR/DEALER": "blue",
        "FRANCHISE/OUTLET PARTNER": "purple",
        "SALE EXECUTIVE": "green",
      };
      return colors[positionName.toUpperCase()] || "grey";
    },
  },
};
</script>
<style scoped>
.nav-text {
  text-decoration: none;
  color: black;
  font-weight: bold;
  font-size: 20px;
}

.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding: 0 8px 0 20px;
}

/* Sub-tabs inside a collapsible group were rendering at the same text size
   as the group header — size them down so the hierarchy reads correctly. */
.v-list-group__items .v-list-item .v-list-item__title {
  font-size: 13px !important;
}
.v-list-group__items .v-list-item .v-icon {
  font-size: 20px !important;
}
</style>
